import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      lang: 'user/lang'
    }),
    locale () {
      return this.lang.split('-')[0]
    }
  },
  methods: {
    t (key) {
      return this.$t(key, this.lang)
    },
    d (date, format) {
      const m = moment(date)
      return m.isValid() ? m.locale(this.locale).format(format || 'L') : ''
    },
    u (ts, format) {
      const m = moment.unix(ts)
      return m.isValid() ? m.locale(this.locale).format(format || 'L') : ''
    }
  }
}
